import React, {Component} from 'react'
import {inject, observer} from 'mobx-react'
import {withRouter} from 'react-router-dom'
import Header from './Header'
import Routes from './Routes'
import UpgradeModal from './Upgrade/Modal'
import Feedback from './Feedback'
import Footer from './Footer'

import style from './app.sass'

@withRouter
@inject('store') @observer
class App extends Component {
  render() {
    const {is_email_verified, is_staff, account} = this.props.store.user.data
    const is_subscribed = account?.is_subscribed || false
    return(
      <div styleName='wrapper'>
        <Header/>
        <div styleName='content'>
          <Routes
            is_subscribed={is_subscribed}
            is_email_verified={is_email_verified}
            is_staff={is_staff}
          />
        </div>
        <UpgradeModal/>
        <Feedback/>
        <Footer/>
      </div>
    )
  }
}

export default App
